import React, { createContext, useContext, useState} from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import { BASE_URL_OPENFORGE } from '../components/Constants';

import { encryptUserData,decryptUserData,decryptUserDataPhp  } from '../Pages/userCrypto';

// Create UserContext
const UserContext = createContext();

// Custom hook to use the UserContext
export const useUser = () => useContext(UserContext);

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  // Login function called on page load
  const handleLogin = async () => {
    try {
      setIsLoading(true);
      const result_res = await axios.get(`${BASE_URL_OPENFORGE}/api/user_authenticate.php`);
      // console.log('Decrypted 12:', result_res);
      const result = decryptUserDataPhp(result_res.data);
      // console.log('Decrypted User1:', result);
      
      if (result.status === 'success') {
        const redirectUrl = localStorage.getItem('redirectUrl');
        setUser(result.data.data);
        setIsLoggedIn(true);
        const encryptedUser = encryptUserData(result.data.data);
        Cookies.set('userDetail', encryptedUser, { expires: 1 / 48 });

        // Cookies.set('userDetail', JSON.stringify(result.data.data.data), { expires: 1 / 48 });
        setIsLoading(false);
        if (redirectUrl) {
          localStorage.removeItem('redirectUrl');
          const rru = `${BASE_URL_OPENFORGE}${redirectUrl}`;
          window.location.href = rru;
        } else {
          navigate('/collabwithgov/');
        }
      } else {
        setIsLoading(false);
        setUser(null);
        setIsLoggedIn(false);
        setError(result.data.message);
        navigate('/collabwithgov/');
      }
    } catch (error) {
        setIsLoading(false);
      setUser(null);
      setError(error);
      setIsLoggedIn(false);
      navigate('/collabwithgov/');
    } 
  };

  // Check user session and update state
  const checkLoginStatus = async () => {
    try {

        const userCookie = Cookies.get('userDetail');
        if (userCookie) {
          const decryptedUser = decryptUserData(userCookie);
          // console.log('Decrypted Userqq:', decryptedUser);
          if (decryptedUser) {
            setUser(decryptedUser);
            setIsLoggedIn(true);
            // continue auth check
      //     }
        }


      // const userCookie = Cookies.get('userDetail');
      // if (userCookie) {
        // setUser(JSON.parse(userCookie));
        // setIsLoggedIn(true);

        const result_res = await axios.get(`${BASE_URL_OPENFORGE}/api/user_authenticate.php`);
        // console.log('Decrypted 22:', result_res);
        const result = decryptUserDataPhp(result_res.data);
        // console.log('Decrypted User2:', result);
        if (result.status === 'error') {
          Cookies.remove('userDetail');
          setUser(null);
          setIsLoggedIn(false);
          window.location.reload();
        }
      } else {
        // If no userCookie, attempt to authenticate
        const result_res = await axios.get(`${BASE_URL_OPENFORGE}/api/user_authenticate.php`);
        // console.log('Decrypted 32:', result_res);
        const result = decryptUserDataPhp(result_res.data);
        // console.log('Decrypted User3:', result);

        if (result.status === 'success') {
          // console.log("32 inner");
          const encryptedUser = encryptUserData(result.data.data);
          Cookies.set('userDetail', encryptedUser, { expires: 1 / 48 });
          // console.log('User plain data:', result.data.data);
          // console.log('User encrypted data:', encryptedUser);
          // Cookies.set('userDetail', JSON.stringify(result.data.data.data), { expires: 1 / 48 });
          setUser(result.data.data);
          setIsLoggedIn(true);
        //   const redirectUrl = localStorage.getItem('redirectUrl');
        //   localStorage.removeItem('redirectUrl');
        //   if (redirectUrl) {
        //     window.location.href = `${BASE_URL_OPENFORGE}${redirectUrl}`;
        //   } else {
        //     window.location.reload();
        //   }
        } else {
          Cookies.remove('userDetail');
          setUser(null);
          setIsLoggedIn(false);
        }
      }
    } catch (error) {
      Cookies.remove('userDetail');
      setUser(null);
      setIsLoggedIn(false);
    }
  };

  // Logout function
  const handleLogout = async () => {
    try {
      const result = await axios.get(`${BASE_URL_OPENFORGE}/api/user_logout.php`);
      if (result.data.status === 'success' || result.data.status === 'error') {
        Cookies.remove('userDetail');
        setUser(null);
        setIsLoggedIn(false);
        window.location.reload();
      }
    } catch (error) {
      console.log('Error during logout:', error);
    }
  };

  return (
    <UserContext.Provider
      value={{
        user,
        isLoggedIn,
        isLoading,
        error,
        handleLogin,
        handleLogout,
        checkLoginStatus,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
